export const postCodeRegEx = {
  default: /^[23456][0-9]{3}$/,
  vic: /^(3[0-9]{3})|(^8[0-9]{3}$)$/,
  nsw: /^(1[0-9]{3}|2[0-4][0-9]{2}|25[0-8][0-9]|259[0-9])|(26[2-8][0-9]|269[0-9]|2[78][0-9]{2})|(292[1-9]|29[3-9][0-9])$/,
  wa: /^6[0-9]{3}$/,
  sa: /^5[0-9]{3}$/,
  qld: /^(4[0-9]{3})|(9[0-9]{3})$/,
  act: /^(0(2[0-8][0-9]|29[0-9]))|(260[0-9]|261[0-8])|(29[01][0-9]|2920)/,
  nt: /^0*(8[0-9]{2}|9[0-8][0-9]|99[0-9])/,
  tas: /^7[0-9]{3}$/
};
